import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";

import { useRef, useState } from "react";

import { IconButton } from "@mui/material";
import { Image } from "react-bootstrap";

import MaleIcon from "../../assets/MaleIcon.svg";
import FemaleIcon from "../../assets/FemaleIcon.svg";

import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";

import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	FormGroup,
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	DialogActions,
	Alert,
	CircularProgress,
	Backdrop,
} from "@mui/material";
import { AddBeneficiary } from "../../services/wapi";
import { otherRelationId } from "../../constants/constant";

export const AddFamilyMember = ({
	visible,
	setVisibility,
	onSuccess,
	data,
}) => {
	const [relation, setRelation] = useState("");
	const [mobNumber, setMobNumber] = useState("");
	const [aliasRelation, setAliasRelation] = useState("");
	const [relationId, setRelationId] = useState("");
	const relationRef = useRef(null);

	const [patientName, setPatientName] = useState("");
	const nameRef = useRef(null);

	const [dob, setDob] = useState(null);

	const [gender, setGender] = useState("F");

	const [isLoading, setLoading] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	useEffect(() => {
		setRelationId(
			relationsArray.filter((rel) => rel.relation === relation)[0]?.relationId,
		);
	}, [relation]);
	const relationsArray = data.availableRelations;

	const isFormValid = () => {
		if (!relation) {
			alert("Please select relation");
			relationRef.current.focus();
			return false;
		}

		if (!patientName) {
			alert("Patient name is required");
			nameRef.current.focus();
			return false;
		}
		if (
			data.isFamilyFlowEnabled &&
			data?.compulsoryFields?.phonenumber &&
			(isNaN(mobNumber) || !mobNumber || mobNumber.length !== 10)
		) {
			alert("Please enter valid mobile number");
			return false;
		}
		if (data.isFamilyFlowEnabled && relation === "Others" && !aliasRelation) {
			alert("Please enter aliasrelation name for others");
			return false;
		}
		if (relation && patientName && dob && gender) return true;
	};

	const submitForm = async () => {
		if (!isFormValid()) return;

		setLoading(true);
		setShowAlert(false);

		try {
			const response = await AddBeneficiary(
				{
					relationName: relation,
					name: patientName,
					dob: dob?.add(10, "hours")?.toISOString(),
					gender,
					mobileNumber: mobNumber,
					relationId: relationId,
					aliasRelation: relationId === otherRelationId ? aliasRelation : null,
				},
				data.shortToken,
			);

			if (!response.isSuccess) throw new Error(response.errorMessage);

			setVisibility(false);
			onSuccess();
		} catch (ex) {
			setShowAlert(true);
		} finally {
			setLoading(false);
		}
	};
	return (
		<>
			<Backdrop open={isLoading} sx={{ zIndex: 99999 }}>
				<CircularProgress />
			</Backdrop>
			<Dialog
				open={visible}
				onClose={() => setVisibility(false)}
				className="bottom-sheet-modal"
			>
				<DialogTitle>Add Family Member</DialogTitle>
				<IconButton
					aria-label="close"
					onClick={() => setVisibility(false)}
					sx={{
						position: "absolute",
						right: 8,
						top: 8,
						color: (theme) => theme.palette.grey[500],
					}}
				>
					<CloseIcon />
				</IconButton>
				<DialogContent style={{ paddingTop: "15px" }}>
					<div className="d-flex justify-content-between align-items-center m-b-30">
						<div className="text-center m-b-30">
							<Image src={gender == "F" ? FemaleIcon : MaleIcon} height="75" />
						</div>
						<div className="d-flex gender-selector">
							<div
								className={`py-2 px-3 border ${gender === "F" ? "active" : ""}`}
								style={{
									borderTopLeftRadius: "20px",
									borderBottomLeftRadius: "20px",
								}}
								onClick={() => setGender("F")}
							>
								Female
							</div>
							<div
								className={`py-2 px-3 border ${gender === "M" ? "active" : ""}`}
								style={{
									borderTopRightRadius: "20px",
									borderBottomRightRadius: "20px",
								}}
								onClick={() => setGender("M")}
							>
								Male
							</div>
						</div>
					</div>
					<FormControl fullWidth>
						<FormGroup>
							<FormControl style={{ marginBottom: "20px" }}>
								<InputLabel id="patient-relation">Relation</InputLabel>
								<Select
									labelId="patient-relation"
									label="Relation"
									value={relation}
									onChange={(e) => {
										setRelation(e.target.value);
										setRelationId(
											relationsArray.filter(
												(rel) => rel.relation === relation,
											)[0]?.relationId,
										);
									}}
									inputRef={relationRef}
								>
									{relationsArray.map((rel, idx) => (
										<MenuItem key={idx} value={rel.relation}>
											{rel.relation}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							{data.isFamilyFlowEnabled && relationId == otherRelationId && (
								<TextField
									label="Alias Relation"
									style={{ marginBottom: "20px" }}
									value={aliasRelation}
									onChange={(e) => setAliasRelation(e.target.value)}
									required
								/>
							)}

							<TextField
								label="Patient name"
								style={{ marginBottom: "20px" }}
								value={patientName}
								onChange={(e) => setPatientName(e.target.value)}
								inputRef={nameRef}
								required
							/>
							{data.isFamilyFlowEnabled &&
								data?.compulsoryFields?.phonenumber && (
									<TextField
										label="Mobile Number"
										style={{ marginBottom: "20px" }}
										value={mobNumber}
										onChange={(e) => setMobNumber(e.target.value)}
										required
									/>
								)}

							<LocalizationProvider dateAdapter={AdapterMoment}>
								<DatePicker
									label="Date of birth"
									value={dob}
									maxDate={moment()}
									onChange={(val) => setDob(val)}
									format="MMM DD, YYYY"
									required
								/>
							</LocalizationProvider>
						</FormGroup>
					</FormControl>
				</DialogContent>
				<DialogActions>
					<Button
						fullWidth
						variant="contained"
						color="primary"
						onClick={submitForm}
					>
						Submit
					</Button>
				</DialogActions>

				{!isLoading && showAlert && (
					<Alert severity="error" sx={{ marginTop: "20px" }}>
						{"Could not process. Please try again"}
					</Alert>
				)}
			</Dialog>
		</>
	);
};
